<div class="container-left-right text-full-word-break mb-{{ mb }} {{ css }}" [ngClass]="{ wiggling: wiggle }">
  <label for="{{ field + '_input' }}">
    <ng-content select="[left]"></ng-content>
  </label>
  <div>
    @if (hasSwitchTooltip.length > 0) {
      <div
        class="toggle-tooltip-overlay"
        bp-tooltip="{{ hasSwitchTooltip | translate }}"
        position="top"
      ></div>
    }
    <div class="toggle" [ngClass]="{ 'mod-z-index-toggle': hasSwitchTooltip.length > 0 }">
      <input
        #input
        class="toggle-input"
        type="checkbox"
        name="{{ field + '_input' }}"
        id="{{ field + '_input' }}"
        (ngModelChange)="onClick()"
        [(ngModel)]="_value"
        [disabled]="disabled" />
      <button
        class="toggle-btn"
				[ngClass]="{
					'toggle-btn-on': _value,
					'toggle-btn-off': !_value,
					'has-error': error || (model && model.hasError(field))
				}"
        [disabled]="disabled"
        [attr.aria-expanded]="_value"
      (click)="onClick()"></button>
    </div>
    @if (error) {
      <span class="form-error">{{ error }}</span>
    }
  </div>
</div>
